import React from 'react';
import {Typography} from '../Typography/Typography';
import {styled} from '@mui/material/styles';

import type {TypographyProps as TProps} from '../Typography/Typography';

export interface FooterListTitleProps extends TProps {
    /**
     * Title text
     */
    text?: string;
}

const StyledType = styled(Typography)<FooterListTitleProps>(({theme}) => ({
    color: theme.tokens.FuelColorGray800,
    paddingLeft: '0.25rem',
    paddingRight: '0.25rem'
}));

export const FooterListTitle = React.forwardRef<HTMLElement, FooterListTitleProps>(({
    text, variant = 'h3', size = 'sm',
    ...props
}, ref): React.ReactElement => (
    <StyledType
        noWrap
        ref={ref}
        size={size}
        variant={variant}
        {...props}
    >{text}</StyledType>
));

FooterListTitle.displayName = 'FooterListTitle';
